module.exports = __webpack_public_path__ + "img/go-to-liveabc.e01f3318.png";